export default defineNuxtPlugin(() => {
    /*
    return {
        provide: {
            authRedirect: async (route: any, config: any) => {
                try {
                    console.log(route.params.org_slug);
                    const user = await $fetch(`/api/${route.params.org_slug}/auth`, {
                        headers: {
                            Accept: 'application/json', // Specify that the client expects JSON
                            'X-Api-Request': 'true',
                        },
                    });
                    if (!user || !user.user || user.user.length === 0) {
                        const loginUrl = `${config.public.apiDomain}/login`;
                        //navigateTo(loginUrl, { external: true });
                    } else {
                        console.log(user);
                    }
                } catch (error) {
                    console.error("Error during auth redirect:", error);
                    //navigateTo('/error');
                }
            },
        },

    };
     */
});
